import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { shallowRef } from "vue";
import router from "./router";
import { LayoutName, layouts } from "./layouts";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const layout = shallowRef(layouts[LayoutName.Default]);
router.afterEach((to: any) => {
  layout.value = layouts[(to.meta?.layout as LayoutName) ?? LayoutName.Default];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), {
    key: _unref(layout).__name
  }))
}
}

})